module.exports = __webpack_public_path__ + "img/digital-card-avatar.6b5421bb.jpg";